const PAGE = {
    BRIEF: 'brief',
    LISTING: 'listing',
};

const SESSION_STATE_KEY = 'logo_maker_mpi_state';

export { PAGE, SESSION_STATE_KEY };
